<template>
    <div  :class="baseerp+'div'" >
        <div class="flex a-i-c jcsb"style="margin:5px 14px" >
            <div class="flex">
                <div>品名</div>
                <el-input v-model="search" placeholder="搜索" size="mini" style="width: 200px" clearable></el-input>
                <div style="margin-left: 10px">业务类型</div>
                <el-select v-model="ywtype" size="mini" >
                    <el-option v-for="item in typeList" :key="item.id" :label="item.text" :value="item.id"></el-option>
                </el-select>
                <div style="margin-left: 10px">归属组</div>
                <el-select v-model="gid" size="mini">
                    <el-option v-for="item in gsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-button  plain style="margin-left: 10px"   size="mini" @click="searchFun" >{{$t('button_search_for')}}</el-button>
            </div>

            <el-button  type="primary" :class="baseerp+'btn'" size="mini" @click="add">新增</el-button>
        </div>
        <div style="padding-right: 9px;padding-left: 9px">
            <el-table class="mrt10" ref="table" size="mini" row-key="id" :height="tableHeight" border :data="tableData"
                      :cell-style="{textAlign:'center !important'}" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
                <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
                <el-table-column :label="$t('form_product_name')" prop="pzname" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="规格" prop="isdalei" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="业务类型" prop="ywtypeStr" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="是否散水" prop="issan" min-width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div style="text-align: center;">{{YoN.find(y=>y.id==scope.row.issan).text}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="是否需要检测" prop="ischeck" min-width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div style="text-align: center;">{{YoN.find(y=>y.id==scope.row.ischeck).text}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="是否需要大屏通知" prop="istvnotice" min-width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div style="text-align: center;">{{YoN.find(y=>y.id==scope.row.istvnotice).text}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="大屏推送区域" prop="tvlocation" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column label="取样形式" prop="gettypeStr"  min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="取样时间点" prop="qynodeStr" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="归属组" prop="bmname" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column label="是否需要厂家质检单" prop="ischeckorder" min-width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div style="text-align: center;">{{YoN.find(y=>y.id==scope.row.ischeckorder).text}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="批次号前缀" prop="pcnumPrefix" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="单位" prop="unit" min-width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div style="text-align: center;" v-if="scope.row.unit == 1">日</div>
                        <div style="text-align: center;" v-if="scope.row.unit == 2">月</div>
                    </template>
                </el-table-column>
                <el-table-column label="合并标识" prop="pcmerge" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="日期格式" prop="dateformat" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="产品代码" prop="pzcode" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="是否需要厂家编码" prop="supplierno" min-width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div style="text-align: center;">{{YoN.find(y=>y.id==scope.row.supplierno).text}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="批次前缀" prop="pcprefix" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
                        <el-button type="text" style="color: red"  @click="deleteRow(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  style="margin-top: 10px;text-align: right"
                            background
                            @current-change="pageCurrentChange"
                            @size-change="sizeChange"
                            :page-sizes="[20,50,100]"
                            layout="total,sizes,prev, pager, next"
                            :current-page.sync="currentPage"
                            :total="total"
                            :page-size="pageSize">
            </el-pagination>

        </div>
         <el-dialog class="cldialog" style="display: flex;justify-content: center;align-items: center;" width="70%" top="30px" height="100%" :title="detailTitle" :visible.sync="detailDialog" v-if="detailDialog" :close-on-click-modal="false" @close="detailClose">
            <detail-page :data="detailData" @close="detailClose"></detail-page>
        </el-dialog>


    </div>
</template>

<script>
    import * as API from "./api"
    import DetailPage from "./DetailPage";
    import {baseerp,file_root} from "@/utils/baseUrl";
    export default {
        name: "index",
        components: {DetailPage},
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                file_root:'',
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                total:0,
                detailDialog:false,
                detailTitle:'编辑',
                detailData:{},
                search:'',
                ywtype:'',
                gid:'',
                status:'',
                type:'',
                statusList:[{id:0,text:'待办'},{id:1,text:'已办'},{id:2,text:'化验'},],
                typeList:[{id:0,text:'全部'},{id:1,text:'成品'},{id:2,text:'销售'},{id:3,text:'原料'},],
                YoN:[{id:0,text:'否'},{id:1,text:'是'}],
                gsList:[],
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp
            this.file_root=file_root
            this.getPzcheckList()
            this.selectGsz()
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100
            },
            searchFun(){
                this.currentPage=1;
                this.getPzcheckList();
            },
            add(){
                this.detailData={
                    id:0
                }
                this.detailDialog=true
            },
            editRow(row){
                this.detailData=row
                this.detailDialog=true
            },
            deleteRow(row){
                this.$confirm('是否确认删除','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.deletePzcheck(row)

                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            detailClose(type='back',data=[]){
                if (type=='back'){

                }else{
                    this.getPzcheckList()
                }
                this.detailDialog=false
            },
            async selectGsz(){
                let param={};
                let res=await API.selectGsz(param);
                if ( res.code == 1 ){
                    let list = [{id: 0, name: '全部'}]
                    this.gsList=list.concat(res.data)

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            searchFun(){
                this.currentPage=1;
                this.getPzcheckList();
            },
            async getPzcheckList(){
                let param={
                    search:this.search,
                    ywtype:this.ywtype,
                    gid:this.gid,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                };
                let res=await API.getPzcheckList(param);
                if ( res.code == 1 ){
                    this.total=res.total;
                    this.tableData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async deletePzcheck(row){
                let param={
                    id:row.id
                };
                let res=await API.deletePzcheck(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.currentPage=1
                    this.getPzcheckList()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getPzcheckList();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getPzcheckList();
            },

        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        /*align-items: center;*/
    }
    .w100{
        width: 100%;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 700px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }

    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .dib{
        display: inline-block;
    }
    .ckys{
        width: 340px;
        display: inline-block;
        margin: 0 4px;
        border: 1px solid #DCDFE6;
    }
    .wi{
        width:inherit;
    }
    .w100-480{
        width: calc(100% - 350px);
    }
    .p-5-9{
        padding: 5px 9px;
    }
    .jcsb{
        justify-content: space-between;
    }
    .a-i-c{
    align-items: center;
    }
</style>